import React, { useEffect, useState } from 'react';
import connect from 'react-redux/lib/connect/connect';
import { dateFormation, fixBetGameData, fixBetsData, getMatchInfo, groupBetGameEvents, groupMarkets, isEmpty, isMobilePage, ResizeESportsIframe, ResizeSportsLiveIframe, sortMarkets } from '../../common/cores';
import { resource_url } from '../../common/cores/keys';
import { socket } from '../../common/cores/socket';
import { sportIds } from '../../utils/names';
// import BetGroup from '../BetGame/BetGroup';
// import SportsGroup from '../sports/SportsGroup';
import MarketItem from './MarketItem';
import BackButton from '../account/BackButton';

const marketNames = require('../../common/cores/market.json')
const eventPartNames = require('../../common/cores/eventpart.json')

const locationUrl = resource_url + "/images/locations/";

// const soccer = [
//     {
//         name: "프리미어쉽",
//         value: "premiership"
//     },
//     {
//         name: "유로컵",
//         value: "euro"
//     },
//     {
//         name: "슈퍼리그",
//         value: "superleague"
//     },
// ]

// const basketBall = [
//     {
//         name: "baker",
//         value: "baker"
//     },
//     {
//         name: "water",
//         value: "water"
//     },
// ]

const Markets = (props) => {

    const [active, setActive] = useState("allMarket")
    useEffect(()=>{
        setActive("allMarket");
    }, [props.sports.activeId]);

    const sportType = props.sportId;
    // const [sportType, setSportType] = useState("soccer")
    // const [activeName, setActiveName] = useState("premiership")
    

    const { data, activeId, url } = props.sports
    const { type, showMarkets, interiorShowMarket, pageInfo, marketNameList, eventpartNameList, sportsMarketInfo } = props;

    let sports = []

    let selectSports
    if (!isEmpty(data)) {

        selectSports = data[data.findIndex((item) => item.key === activeId)];
    }
    let kind_Id = "";
    if(!isEmpty(sportsMarketInfo)){
        kind_Id = type === 'esports' ? sportsMarketInfo.Fixture.League.sport.oddsId : sportsMarketInfo.Fixture.League.sport.Id
    }
    let originSportslist = !isEmpty(sportsMarketInfo) ? sortMarkets(sportsMarketInfo, kind_Id) : {};
    let matchInfo = getMatchInfo(originSportslist);
    let { imgPath, leagueName, sportName, homeTeam, awayTeam, time, sportImg } = matchInfo;

    let goruplist = groupMarkets(originSportslist);
    if (!isEmpty(goruplist)) {
        goruplist.forEach(element => {
            goruplist[0].data = goruplist[0].data.concat(element.data);
        });
    }
    
    return  (
        <div className="sport_more_wrap">
				<div className={`sport_more_box ${!interiorShowMarket && "sport_more_list_anim_none"}`}>
                    {
                            !isEmpty(goruplist.filter(item => { return item.type == active }))&& goruplist.filter(item => { return item.type == active })[0].data.map((item, index) => {
                                // console.log(item);
                                const activeGroup = goruplist.filter(item => { return item.type == active })[0].data;
                                const groupItem =activeGroup[index];
                                const fixedList = fixBetsData(groupItem.Providers[0], groupItem.Id, type, false, originSportslist);
                                    // debugger

                                    // ------------------------- 마켓네임, 이벤트파트 아이디 ------------------------- //
                                    let marketNameIndex;
                                    let markettitle = "";
                                    if(!isEmpty(marketNameList)){
                                        marketNameIndex = marketNameList.findIndex(name =>  name.marketId == groupItem.Id);
                                        if((marketNameIndex > -1)){
                                            markettitle += marketNameList[marketNameIndex].translate + " ";
                                        }
                                    }else {
                                        marketNameIndex = marketNames.findIndex(name =>  name.id == groupItem.Id);
                                        if((marketNameIndex > -1)){
                                            markettitle += marketNames[marketNameIndex].translate + " ";
                                        }
                                    }
                                    let eventPartNameIndex;
                                    let eventParttitle = "";
                                    // const eventPartNameIndex = eventPartNames.findIndex(name =>  name.id == groupItem.eventPartId);
                                   
                                    if(!isEmpty(eventpartNameList)){
                                        eventPartNameIndex = eventpartNameList.findIndex(name =>  name.eventpartId == groupItem.eventPartId);
                                        if((eventPartNameIndex > -1)){
                                            eventParttitle += eventpartNameList[eventPartNameIndex].kor_name;
                                        }
                                    }
                                    else {
                                        eventPartNameIndex = eventpartNameList.findIndex(name =>  name.eventpartId == groupItem.eventPartId);
                                        if((eventPartNameIndex > -1)){
                                            eventParttitle += eventPartNames[eventPartNameIndex].kor_name;
                                        }
                                    }
                                    // ------------------------- 마켓네임, 이벤트파트 아이디 ------------------------- //


                                    return  ( 
                                        <MarketItem 
                                        betItemList={fixedList}
                                        originSportslist={originSportslist}
                                        market={item}
                                        active={activeId === originSportslist.key}
                                        key={index}
                                        hideTitle={index === 0 ? false : (groupItem.Id === activeGroup[index - 1].Id) && (groupItem.eventPartId === activeGroup[index - 1].eventPartId)}
                                        markettitle={markettitle}
                                        eventParttitle={eventParttitle}
                                        kind_Id={kind_Id}
                                        interiorShowMarket={interiorShowMarket}
                                        />
                                    )
                                
                            })
                        }
					
				</div>
			</div>	
    );
};

const mapStateToProps = state => ({
    sports: state.sports,
    pageInfo: state.page.pageInfo,
    marketNameList: state.user.marketNameList,
    eventpartNameList: state.user.eventpartNameList,
    sportsMarketInfo:state.sports.sportsMarketInfo
});

export default connect(mapStateToProps, {})(Markets);


// WEBPACK FOOTER //
// ./src/components/sports/Markets.js